import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OutsideClickHandler from 'react-outside-click-handler';
import _noop from 'lodash/noop';

// Constants
import { EMPTY_OBJECT, EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';
import { HIDE_FILTER_POPOVER, SHOW_FILTER_POPOVER, REFRESH_FILTER_TYPES } from './constants/filterDialogSection.actionTypes';

// Components
import Popover from '../../../../../molecules/popover';
import FilterContent from '../filterContent';
import FilterHeader from '../filterHeader';

// Styles
import s from './filterDialogSection.module.scss';
var FilterDialogSection = /*#__PURE__*/function (_Component) {
  _inherits(FilterDialogSection, _Component);
  var _super = _createSuper(FilterDialogSection);
  function FilterDialogSection() {
    var _this;
    _classCallCheck(this, FilterDialogSection);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleVisibleChange", function (visible) {
      if (visible) {
        return _this.handleShow();
      }
      return _this.handleHide();
    });
    _defineProperty(_assertThisInitialized(_this), "handleHide", function () {
      var onAction = _this.props.onAction;
      onAction({
        type: HIDE_FILTER_POPOVER
      });
    });
    return _this;
  }
  _createClass(FilterDialogSection, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevFilterTypes = prevProps.filterTypes,
        previousValues = prevProps.values;
      var _this$props = this.props,
        filterTypes = _this$props.filterTypes,
        values = _this$props.values;

      // Recompute Fields and sections whenever filterTypes changes.
      if (filterTypes !== prevFilterTypes || previousValues !== values) {
        var onAction = this.props.onAction;
        onAction({
          type: REFRESH_FILTER_TYPES
        });
      }
    }
  }, {
    key: "handleShow",
    value: function handleShow() {
      var onAction = this.props.onAction;
      onAction({
        type: SHOW_FILTER_POPOVER
      });
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this$props2 = this.props,
        onAction = _this$props2.onAction,
        fields = _this$props2.fields,
        sections = _this$props2.sections,
        values = _this$props2.values,
        isModified = _this$props2.isModified,
        showReset = _this$props2.showReset,
        showAddFilter = _this$props2.showAddFilter,
        isReadOnly = _this$props2.isReadOnly,
        filterGroups = _this$props2.filterGroups,
        selectedFilterGroup = _this$props2.selectedFilterGroup,
        editMode = _this$props2.editMode,
        filterGroupName = _this$props2.filterGroupName,
        errors = _this$props2.errors,
        shouldHideSaveFilterGroup = _this$props2.shouldHideSaveFilterGroup,
        shouldHideFilterGroup = _this$props2.shouldHideFilterGroup,
        shouldCloseOnOutsideClick = _this$props2.shouldCloseOnOutsideClick,
        nonRenamable = _this$props2.nonRenamable,
        nonDeletable = _this$props2.nonDeletable;
      var popoverContent = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FilterHeader, {
        filterGroups: filterGroups,
        selectedFilterGroup: selectedFilterGroup,
        onAction: onAction,
        isModified: isModified,
        editMode: editMode,
        shouldHideSaveFilterGroup: shouldHideSaveFilterGroup,
        shouldHideFilterGroup: shouldHideFilterGroup,
        filterGroupName: filterGroupName,
        errors: errors,
        isReadOnly: isReadOnly,
        nonRenamable: nonRenamable,
        nonDeletable: nonDeletable
      }), /*#__PURE__*/React.createElement(FilterContent, {
        onAction: onAction,
        fields: fields,
        sections: sections,
        values: values,
        isModified: isModified,
        showReset: showReset,
        showAddFilter: showAddFilter,
        isReadOnly: isReadOnly
      }));
      return shouldCloseOnOutsideClick ? /*#__PURE__*/React.createElement(OutsideClickHandler, {
        onOutsideClick: this.handleHide
      }, popoverContent) : popoverContent;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        children = _this$props3.children,
        isPopoverVisible = _this$props3.isPopoverVisible,
        placement = _this$props3.placement,
        getPopupContainer = _this$props3.getPopupContainer,
        filterPopoverClass = _this$props3.filterPopoverClass;
      return /*#__PURE__*/React.createElement(Popover, {
        content: this.renderContent(),
        onVisibleChange: this.handleVisibleChange,
        overlayClassName: "".concat(s.overlay, " ").concat(filterPopoverClass),
        trigger: "click",
        visible: isPopoverVisible
        // The two props below are necessary to avoid  =closing the contextual dialog onDocument click
        ,
        maskClosable: false,
        mask: true,
        placement: placement,
        getPopupContainer: getPopupContainer
      }, children);
    }
  }]);
  return FilterDialogSection;
}(Component);
FilterDialogSection.propTypes = _objectSpread(_objectSpread({}, FilterHeader.propTypes), {}, {
  children: PropTypes.node.isRequired,
  onAction: PropTypes.func,
  fields: PropTypes.object,
  sections: PropTypes.array,
  values: PropTypes.object,
  isPopoverVisible: PropTypes.bool,
  showAddFilter: PropTypes.bool,
  placement: PropTypes.string,
  getPopupContainer: PropTypes.func,
  shouldHideSaveFilterGroup: PropTypes.bool,
  shouldHideFilterGroup: PropTypes.bool,
  filterPopoverClass: PropTypes.string,
  isReadOnly: PropTypes.bool,
  shouldCloseOnOutsideClick: PropTypes.bool,
  nonRenamable: PropTypes.bool,
  nonDeletable: PropTypes.bool
});
FilterDialogSection.defaultProps = _objectSpread(_objectSpread({}, FilterHeader.defaultProps), {}, {
  onAction: _noop,
  fields: EMPTY_OBJECT,
  sections: EMPTY_ARRAY,
  values: EMPTY_OBJECT,
  isPopoverVisible: false,
  showAddFilter: true,
  placement: 'bottomLeft',
  getPopupContainer: undefined,
  shouldHideSaveFilterGroup: false,
  shouldHideFilterGroup: false,
  filterPopoverClass: '',
  isReadOnly: false,
  shouldCloseOnOutsideClick: false,
  nonRenamable: false,
  nonDeletable: false
});
export default FilterDialogSection;